import React, { createContext, useContext, useMemo, useState } from 'react';
//interfaces
import { UpdateConversionFactorProps } from 'models/MapProduct';
import { ConversionFactorContextProviderProps, ConversionFactorContextType } from './interface';
//components
import { toastify } from 'components/Toastify/utils';
//services
import MapProductsServices from 'services/quoteMapProduct.service';
//context
import { useDetailsQuoteContext } from 'contexts/DetailsQuote';

export const ConversionFactorContext = createContext({} as ConversionFactorContextType);

export function ConversionFactorContextProvider(props: ConversionFactorContextProviderProps) {
  const { item, children } = props;

  const _mapProductServices = new MapProductsServices();
  const suggested = useMemo(() => (item.productsSuggestion?.find((i: any) => item.budgets?.sequence ? Number(i.sequentialSuggestion) === (item.budgets?.sequence + 1) : i.suggested)), [item]);
  const [conversionFactor, setConversionFactor] = useState((suggested?.conversionFactor ? suggested.conversionFactor : 0));
  const [oldConversionFactor, setOldConversionFactor] = useState((suggested?.conversionFactor ? suggested.conversionFactor : 0));

  const { quoteItem } = useDetailsQuoteContext();

  const updateConversionFactorItem = async () => {
    if (conversionFactor && conversionFactor > 0 && oldConversionFactor !== conversionFactor) {
      setOldConversionFactor(conversionFactor);

      const data: UpdateConversionFactorProps = {
        conversionFactor: Number(conversionFactor),
        hospitalProductCode: item.productCode!,
        hospitalDocumentNumber: item.buyerIdentifier!,
        supplierProductCode: suggested?.supplierProductcode!
      };

      const response = await _mapProductServices.UpdateConversionFactor(data);

      if (response.status !== 200)
        toastify.error("Falha ao atualizar fator de conversão.");
    }
  };

  const updateConversionFactorState = () => {
    const index = quoteItem?.data?.findIndex(i => i.sequenceNumber === item.sequenceNumber && item.productsSuggestion && item.productsSuggestion.length > 0);
    const indexSuggested = item?.productsSuggestion?.findIndex(i => i.supplierProductcode === suggested?.supplierProductcode);
    
    if (index !== -1 && indexSuggested !== -1) {
      const newConversionFactor = quoteItem!.data![index!].productsSuggestion![indexSuggested!].conversionFactor ?? 0;
      setConversionFactor(newConversionFactor);
    }
  };

  return (
    <ConversionFactorContext.Provider value={{
      conversionFactor,
      setConversionFactor,
      updateConversionFactorItem,
      updateConversionFactorState
    }}>
      {children}
    </ConversionFactorContext.Provider>
  );
}

export const useConversionFactorContext = () => {
  return useContext(ConversionFactorContext);
};